import React from "react";
import "../styles/AdmissionForm.css";
import { FaFilePdf } from "react-icons/fa";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// PDF file
import Admission_Form from "../Assets/Pdfs/Admission_Form.pdf";

export default function AdmissionForm() {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <div className="admission-form-page">
      <section className="admission-form-section pdf-section">
        <h2>
          <FaFilePdf className="pdf-icon" /> Admission Form
        </h2>

        <div className="pdf-viewer">
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer
              fileUrl={Admission_Form}
              plugins={[defaultLayoutPluginInstance]}
            />
          </Worker>
        </div>

        <p className="pdf-download">
          <a href={Admission_Form} target="_blank" rel="noopener noreferrer">
            Download Admission Form
          </a>
        </p>
      </section>
    </div>
  );
}
